import { Box, Button, DialogContentText, MenuItem, Select, Stack, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { ICylinder } from '../../interface/IOrders_Tasks';
import { AxiosInstance } from '../../api/apiInstance';
export interface DialogCreateRmaProps {

    setDialogEditRmaTask: (id: any, value: any, name: any) => void;
    setTakePicture: (openTrue: boolean) => void;
    singleTaskEdit: any;
    _clearPicture: () => void;
    _handleScanChange: (e: any) => void;
    onKeyPressBarcode: (e: any) => void;
    barcode: string;
}

function DialogEditRma(props: DialogCreateRmaProps) {
    const [cylinderData, setCylinderData] = React.useState<ICylinder[]>([] as ICylinder[]);
    const { barcode, setDialogEditRmaTask, singleTaskEdit, setTakePicture, _clearPicture,
        _handleScanChange, onKeyPressBarcode } = props;
    useEffect(() => {
        GetData();
    }, []);
    async function GetData() {
        await AxiosInstance({
            // url of the api endpoint (can be changed)
            url: "cylinder",
            method: "GET",
        }).then((res) => {
            // handle success
            const AllData = res.data as ICylinder[];
            setCylinderData(AllData);
        })
    }
    return (
        <Box sx={{ my: 2 }}>
            <Stack direction={'row'} sx={{ mt: 1 }} spacing={2}>
                <TextField
                    sx={{ mt: 1 }}
                    id="rmaNumber" // change field "QTYassembled"
                    label="RMA Number"
                    fullWidth
                    variant="outlined"
                    name="rmaNumber"
                    onChange={event => setDialogEditRmaTask(singleTaskEdit.id, event.target.value, event.target.name)}
                    value={singleTaskEdit?.rmaNumber} />
                <TextField
                    sx={{ mt: 1 }}
                    id="trackingNumber" // change field "QTYassembled"
                    label="tracking Number"
                    fullWidth
                    variant="outlined"
                    name="trackingNumber"
                    onChange={event => setDialogEditRmaTask(singleTaskEdit.id, event.target.value, event.target.name)}
                    value={singleTaskEdit?.trackingNumber} />
            </Stack>
            <TextField
                sx={{ mt: 1 }}
                id="customerName" // change field "QTYassembled"
                label="customer Name"
                fullWidth
                variant="outlined"
                name="customerName"
                onChange={event => setDialogEditRmaTask(singleTaskEdit.id, event.target.value, event.target.name)}
                value={singleTaskEdit?.customerName} />
            <Stack direction={'row'} sx={{ mt: 1 }} spacing={2}>

                <TextField autoComplete='off' id="outlined-basic" variant="outlined"
                    value={barcode}
                    label="Scan"
                    autoFocus
                    onChange={_handleScanChange}
                    onKeyDown={onKeyPressBarcode}
                />
                <TextField
                    sx={{ mt: 1 }}
                    id="PartNumber" // change field "QTYassembled"
                    label="Part Number"
                    fullWidth
                    variant="outlined"
                    name="PartNumber"
                    onChange={event => setDialogEditRmaTask(singleTaskEdit.id, event.target.value, event.target.name)}
                    value={singleTaskEdit?.PartNumber} />
                <TextField
                    sx={{ mt: 1 }}
                    id="QTY" // change field "QTYassembled"
                    label="Quantity"
                    type="number"
                    fullWidth
                    variant="outlined"
                    name="QTY"
                    onChange={event => setDialogEditRmaTask(singleTaskEdit.id, event.target.value, event.target.name)}
                    value={singleTaskEdit.QTY} />
            </Stack>



            <Stack direction={'row'} sx={{ mt: 1 }} spacing={2}>

                <Stack direction={'column'}>
                    <DialogContentText style={{ 'color': 'black' }} variant="h6">back To Inventory</DialogContentText>
                    <Select
                        sx={{ mt: 1 }}
                        labelId="demo-simple-select-label"
                        id="backToInventory"
                        name="backToInventory"
                        value={singleTaskEdit.backToInventory || 0}
                        label="back To Inventory"
                        onChange={event => setDialogEditRmaTask(singleTaskEdit.id, event.target.value, event.target.name)}
                    >
                        <MenuItem value={0}>Yes</MenuItem>
                        <MenuItem value={1}>No</MenuItem>
                    </Select>
                </Stack>
                <Stack direction={'column'}>
                    <DialogContentText style={{ 'color': 'black' }} variant="h6">Product status</DialogContentText>
                    <Select
                        sx={{ mt: 1 , color: 'red'}}
                        labelId="demo-simple-select-label"
                        id="statusRma"
                        name="statusRma"
                        value={singleTaskEdit.statusRma}
                        label="statusRma"
                        onChange={event => setDialogEditRmaTask(singleTaskEdit.id, event.target.value, event.target.name)}
                    >
                        <MenuItem value={0}>Good</MenuItem>
                        <MenuItem value={1}>Not Good</MenuItem>
                    </Select>
                </Stack>
                
            </Stack>
            <Stack direction={'column'}>
                    <DialogContentText style={{ 'color': 'black' }} variant="h6">key Type</DialogContentText>

                    <Select
                        sx={{ mt: 1 }}
                        
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={singleTaskEdit.cylinder || 'Not-Needed'}
                        label="cylinder"
                        name="cylinder"
                        onChange={event => setDialogEditRmaTask(singleTaskEdit.id, event.target.value, event.target.name)}

                    >
                        {cylinderData.map((c) => {
                            return (
                                <MenuItem  value={c.partName}>{c.partName + ' ' + c.description}</MenuItem>
                            )
                        })}

                    </Select>
                </Stack>
            <TextField
                sx={{ mt: 1 }}
                id="taskInfo" // change field "QTYassembled"
                label="Remarks"
                fullWidth
                variant="outlined"
                name="taskInfo"
                onChange={event => setDialogEditRmaTask(singleTaskEdit.id, event.target.value, event.target.name)}
                value={singleTaskEdit.taskInfo} />
            <Stack direction={'row'} sx={{ mt: 1 }} spacing={2}>
                <Stack direction={'column'} sx={{ mt: 1 }} spacing={2}>
                    <Button
                        sx={{ maxHeight: '30px' }}
                        size="small"
                        variant="contained"
                        onClick={() => setTakePicture(true)}>picture</Button>
                    <Button
                        sx={{ maxHeight: '30px' }}
                        size="small"
                        variant="contained"
                        onClick={() => {
                            _clearPicture()
                        }}>Clear </Button>
                </Stack>
                {singleTaskEdit.pictureOne !== null && singleTaskEdit.pictureOne !== ''
                    && singleTaskEdit.pictureOne !== undefined ?
                    <>
                        <div >

                            <img style={{ maxWidth: '250px' }} src={singleTaskEdit.pictureOne} alt="Screenshot" />
                        </div>
                    </> : <></>
                }
                {singleTaskEdit.pictureTwo !== null && singleTaskEdit.pictureTwo !== ''
                    && singleTaskEdit.pictureTwo !== undefined ?
                    <>
                        <div >

                            <img style={{ maxWidth: '250px' }} src={singleTaskEdit.pictureTwo} alt="Screenshot" />
                        </div>
                    </> : <></>
                }
            </Stack>


        </Box>

    )
}

export default DialogEditRma
